import { IconButton, Stack, styled, Tooltip, tooltipClasses } from '@mui/material';
import { Add, ChevronRight, ExpandMore } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';

const StyledHeader = styled(Stack)({
  height: '36px',
  lineHeight: '36px',
  borderTop: '1px solid #E0E0E0',
  textTransform: 'uppercase',
});

interface ISubItemHeader {
  count: number;
  onAdd: () => void;
  canAdd: boolean;
  isExpanded: boolean;
  onToggle: () => void;
}

export function SubItemHeader({ count, onAdd, canAdd, isExpanded, onToggle }: ISubItemHeader) {
  const { t } = useTranslation();
  const addSubItemLabel = t(($) => $.views.visualization.subItems.addSubItemAriaLabel);
  return (
    <StyledHeader direction="row" alignItems="center" justifyContent="space-between">
      <span className="text-xs font-semibold leading-3 text-text-neutral-secondary">
        {count > 0
          ? t(($) => $.views.visualization.subItems.sectionLabelWithCount, { count })
          : t(($) => $.views.visualization.subItems.sectionLabel)}
      </span>
      <Stack direction="row" alignItems="center">
        {count > 0 && canAdd && isExpanded && (
          <Tooltip
            title={addSubItemLabel}
            placement="top-end"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: '4px',
                    },
                },
              },
            }}
          >
            <IconButton
              size="small"
              aria-label={addSubItemLabel}
              onClick={onAdd}
              sx={{ padding: '2px' }}
            >
              <Add />
            </IconButton>
          </Tooltip>
        )}
        {count > 0 && (
          <IconButton
            size="small"
            onClick={onToggle}
            aria-label={t(($) =>
              isExpanded
                ? $.views.visualization.subItems.collapseSectionAriaLabel
                : $.views.visualization.subItems.expandSectionAriaLabel,
            )}
            aria-expanded={isExpanded}
            sx={{ padding: '2px' }}
          >
            {isExpanded ? <ExpandMore size={16} /> : <ChevronRight size={16} />}
          </IconButton>
        )}
      </Stack>
    </StyledHeader>
  );
}
